__webpack_require__.p = "https://gamezone.rydercup.com/pinpoint/";